import { useCallback } from 'react';
import { BiCtaNames, BiModalTypes, BiScreenTypes } from '../../../bi/types';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useReorganizePagesDOMOrder } from './use-reorganize-pages-dom-order';
export const useDomOrderOnApply = _ref => {
  let {
    setIsApplyTriggered
  } = _ref;
  const {
    reorganizePagesDOMOrder
  } = useReorganizePagesDOMOrder();
  const biLogger = useBiLogger();
  const getOnApply = useCallback(_ref2 => {
    let {
      isManuallyCompleted,
      updateRuleState,
      uiStatus
    } = _ref2;
    const handleCancel = () => biLogger.modalCtaClick({
      ctaName: BiCtaNames.Cancel,
      modalType: BiModalTypes.UnableToOrganizeDOMOrder
    });
    const handleTryAgain = async fixOption => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.TryAgain,
        modalType: BiModalTypes.UnableToOrganizeDOMOrder
      });
      if (fixOption) {
        biLogger.taskElementCtaClick({
          ctaName: BiCtaNames.Apply,
          index: 0,
          status: uiStatus
        });
        await reorganizePagesDOMOrder({
          fixOption,
          handleCancel,
          handleTryAgain,
          isManuallyCompleted,
          screenType: BiScreenTypes.DetectedIssues
        });
      }
    };
    const applyFunc = async fixOption => {
      biLogger.taskElementCtaClick({
        ctaName: BiCtaNames.Apply,
        index: 0,
        status: uiStatus
      });
      await reorganizePagesDOMOrder({
        fixOption,
        handleCancel,
        handleTryAgain,
        isManuallyCompleted,
        screenType: BiScreenTypes.DetectedIssues
      });
      updateRuleState(fixOption);
      setIsApplyTriggered(true);
    };
    return applyFunc;
  }, [setIsApplyTriggered, biLogger, reorganizePagesDOMOrder]);
  return {
    getOnApply
  };
};
//# sourceMappingURL=use-dom-order-on-apply.js.map